// Mirrors ImperansCRM.Common.Enums.CompanyGridScopeEnum
export enum CompanyGridScope {
  Home = 1,
  Prospects = 2
}
